
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/slots/[slotId]",
      function () {
        return require("private-next-pages/slots/[slotId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/slots/[slotId]"])
      });
    }
  